<template>
    <div class="is-block pl-2">
        <div class="px-1 pb-4">
            <p class="has-text-weight-bold is-size-6 is-uppercase">{{ $t('project_changes_list') }}</p>
            <p class>{{ $t('project_changes_list_description') }}</p>
            <section class="pt-4">
                <app-search-bar
                    v-model="textSearch"
                    :filter.sync="selectedFilter"
                    :options="options"
                />
            </section>
        </div>
        <div class="lb-separator" />
        <div
            :class="windowSize != 'desktop' ? 'pr-6' : 'pr-5'"
            class="lb-project-changes pt-4 has-scroll-y is-scroll-hidden"
        >
            <article
                v-for="item in filteredItems"
                :ref="item._id"
                :key="item._id"
                :class="{
                    'is-success': item.action == 'ADD',
                    'is-danger': item.action == 'REMOVE',
                    'is-warning': item.action == 'MODIFY',
                    'is-clickable': item.project != item.object,
                }"
                class="message is-small"
            >
                <div class="message-body" @click="processClick(item)">
                    <strong>
                        {{
                        new Date(item.created).toLocaleDateString('es', {
                        hour: '2-digit',
                        minute: '2-digit',
                        })
                        }}
                    </strong>
                    - {{ item.owner.username }}
                    <p class="has-text-weight-bold">
                        {{
                        $store.getters.itemById(item.object) | extractTitle
                        }}
                    </p>
                    <p>
                        {{
                        $t(
                        'project.history.' +
                        item.action +
                        '_' +
                        item.field
                        )
                        }}
                    </p>
                </div>
            </article>
        </div>
    </div>
</template>

<script>
import AppSearchBar from '@/components/AppSearchBar';
import { Document } from 'flexsearch';
import _ from 'underscore';
export default {
    components: {
        AppSearchBar,
    },
    filters: {
        extractTitle(object) {
            return object ? object.title : '';
        },
    },
    data() {
        return {
            selectedFilter: this.$t(
                'Constants.FILTER_OPTION_PROJECT_CHANGES_ALL'
            ),
            textSearch: undefined,
            searchIndex: new Document({
                resolution: 3,
                tokenize: 'full',
                document: {
                    id: '_id',
                    index: [
                        'owner:username',
                        'owner:name',
                        'owner:email',
                    ],
                },
            }),
            options: [
                this.$t('Constants.FILTER_OPTION_PROJECT_CHANGES_ALL'),
                this.$t('Constants.FILTER_OPTION_PROJECT_CHANGES_NEW'),
                this.$t('Constants.FILTER_OPTION_PROJECT_CHANGES_REMOVED'),
                this.$t('Constants.FILTER_OPTION_PROJECT_CHANGES_MODIFIED'),
                this.$t('Constants.FILTER_OPTION_PROJECT_CHANGES_COMMENTS'),
                this.$t('Constants.FILTER_OPTION_PROJECT_CHANGES_PARTICIPANTS'),
            ],
        };
    },
    computed: {
        items() {
            return this.$store.getters.projectChanges;
        },
        filteredItems() {
            let items;
            this.items.forEach((item) => {
                this.searchIndex.remove(item);
            });
            switch (this.selectedFilter) {
                case this.$t('Constants.FILTER_OPTION_PROJECT_CHANGES_NEW'):
                    items = this.items.filter((item) => {
                        return item.action == 'ADD' && item.field == 'OBJECT';
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECT_CHANGES_REMOVED'):
                    items = this.items.filter((item) => {
                        return (
                            item.action == 'REMOVE' && item.field == 'OBJECT'
                        );
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECT_CHANGES_MODIFIED'):
                    items = this.items.filter((item) => {
                        return item.action == 'MODIFY' && item.project;
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECT_CHANGES_COMMENTS'):
                    items = this.items.filter((item) => {
                        return item.field == 'COMMENT';
                    });
                    break;
                case this.$t('Constants.FILTER_OPTION_PROJECT_CHANGES_PARTICIPANTS'):
                    items = this.items.filter((item) => {
                        return item.field == 'SHAREDWITH';
                    });
                    break;
                default:
                    items = this.items;
            }
            if (this.textSearch) {
                items.forEach((item) => {
                    this.searchIndex.add(item);
                });
                const result = this.searchIndex.search(this.textSearch);
                const ids = _.chain(result).pluck('result').flatten().value();
                return this.items.filter((item) => {
                    return _.contains(ids, item._id);
                });
            }

            return items;
        },
        filteredItemsLength() {
            return this.filteredItems.length;
        },
        windowSize() {
            return this.$mq;
        },
    },
    watch: {
        filteredItemsLength: {
            handler: function (newItems, oldItems) {
                if (newItems.length > 0) {
                    this.scrollToItem();
                }
            },
        },
        items: {
            handler: function () {
                //console.log('adding items to search', this.items.length);
                //this.searchIndex.add(this.items);
                this.items.forEach((item) => {
                    this.searchIndex.add(item);
                });
            },
            immediate: true,
        },
    },
    mounted() {
        this.$store.dispatch('fetchProjectChanges');
    },
    methods: {
        scrollToItem() {
            const lastMessage = _.first(this.filteredItems);
            if (lastMessage) {
                this.$nextTick(() => {
                    this.$refs[lastMessage._id][0].scrollIntoView();
                });
            }
        },
        processClick(item) {
            if (item.object != item.project) {
                this.$emit('openObject', { _id: item.object });
            }
        },
    },
};
</script>

<style scoped></style>
